import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import saveAs from "file-saver";
import * as XLSX from "xlsx";
import "./index.css";

/* Actions */
import { setUsersCount, setCompletedUsers, setIncompleteUsers, addCompletedUsers, addIncompleteUsers, removeCandidateFromTheList } from "../../../../redux/actions/admin";
import { setAlert } from "../../../../redux/actions/misc";

/* Components */
import UsersListHeader from "../../../../components/UsersListHeader";
import UsersList from "../../../../components/UsersList";

/* API requests */
import { getSignUpsCount, getSignUps, getMoreSignUps, searchSignUps } from "../../../../api-requests/admin";

const PAGE_SIZE = 50;

const SearchIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <circle cx={11} cy={11} r={8} stroke="currentColor" strokeWidth={2} />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

class SignUps extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active: true,
            keyword: "",
            searchResults: [],
            isFetchingSearchResults: false,
            isFetchingMore: false,
            hasMoreCompleted: true,
            hasMoreIncomplete: true,
        };

        this.searchTimeOut = null;
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);

        getSignUpsCount()
            .then(data => this.props.setUsersCount(data));

        if (this.props.match.path.includes("incomplete")) {
            return this.setState({ active: false }, () => {
                return getSignUps(false).then(data => {
                    this.props.setIncompleteUsers(data);
                    this.setState({ hasMoreIncomplete: Array.isArray(data) && data.length >= PAGE_SIZE });
                });
            });
        }
        return getSignUps(true).then(data => {
            this.props.setCompletedUsers(data);
            this.setState({ hasMoreCompleted: Array.isArray(data) && data.length >= PAGE_SIZE });
        });
    }

    handleLoadMore = () => {
        if (this.state.isFetchingMore) return;
        const onCompleted = this.state.active;
        const hasMore = onCompleted ? this.state.hasMoreCompleted : this.state.hasMoreIncomplete;
        if (!hasMore) return;

        const currentList = onCompleted ? this.props.admin.completedUsers : this.props.admin.incompleteUsers;
        const skip = (currentList || []).length;

        this.setState({ isFetchingMore: true });
        return getMoreSignUps(onCompleted, skip).then(data => {
            const next = Array.isArray(data) ? data : [];
            if (next.length > 0) {
                if (onCompleted) this.props.addCompletedUsers(next);
                else this.props.addIncompleteUsers(next);
            }
            this.setState({
                isFetchingMore: false,
                ...(onCompleted
                    ? { hasMoreCompleted: next.length >= PAGE_SIZE }
                    : { hasMoreIncomplete: next.length >= PAGE_SIZE }),
            });
        });
    };

    exportXlsx = () => {
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        return fetch("/api/users/spreadsheet")
            .then(res => res.json())
            .then(json => {
                const ws = XLSX.utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                return saveAs(data, `Users${fileExtension}`);
            })
            .catch(err => console.log(err));
    }

    handleTabSwitch = (tab) => {
        return this.setState({ active: tab, keyword: "", searchResults: [] }, () => {
            if (tab) {
                getSignUps(tab).then(data => {
                    this.props.setCompletedUsers(data);
                    this.setState({ hasMoreCompleted: Array.isArray(data) && data.length >= PAGE_SIZE });
                });
            } else {
                getSignUps(tab).then(data => {
                    this.props.setIncompleteUsers(data);
                    this.setState({ hasMoreIncomplete: Array.isArray(data) && data.length >= PAGE_SIZE });
                });
            }
            return getSignUpsCount().then(data => this.props.setUsersCount(data));
        });
    }

    handleSearch = (keyword, tab) => {
        return this.setState({ keyword }, () => {
            if (keyword.length >= 5) {
                return this.setState({ isFetchingSearchResults: true }, () => {
                    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
                    this.searchTimeOut = setTimeout(() => {
                        return searchSignUps(tab, keyword)
                            .then(result => this.setState({ searchResults: result.users, isFetchingSearchResults: false }));
                    }, 1000);
                });
            }
            return this.setState({ searchResults: [], isFetchingSearchResults: false });
        });
    }

    handleUsersList = (completedUsers, inCompleteUsers, searchResults, state, keyword) => {
        if (searchResults.length > 0 && keyword.length >= 5) return searchResults;
        if (state) return completedUsers;
        return inCompleteUsers;
    }

    render() {

        const onCompleted = !this.props.match.path.includes("incomplete");
        const completedCount = this.props.admin.completedUsersCount;

        return(
            <div className="admin-page sign-ups-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">Sign ups</h1>
                        <p className="admin-page-subtitle">Review new candidates and verify their profiles.</p>
                    </div>
                    <button type="button" className="admin-page-action admin-page-action--ghost" onClick={() => this.exportXlsx()}>
                        <DownloadIcon />
                        <span>Export</span>
                    </button>
                </header>

                <div className="admin-toolbar">
                    <nav className="admin-tabs" aria-label="Sign up status">
                        <Link to={"/sign-ups/completed"} className={`admin-tab${onCompleted ? " is-active" : ""}`} onClick={() => this.handleTabSwitch(true)}>
                            <span className="admin-tab-label">Completed</span>
                            {completedCount > 0 && <span className="admin-tab-count">{completedCount}</span>}
                        </Link>
                        <Link to={"/sign-ups/incomplete"} className={`admin-tab${!onCompleted ? " is-active" : ""}`} onClick={() => this.handleTabSwitch(false)}>
                            <span className="admin-tab-label">Incomplete</span>
                        </Link>
                    </nav>

                    <div className="admin-search">
                        <span className="admin-search-icon"><SearchIcon /></span>
                        <input
                            type="text"
                            value={this.state.keyword}
                            onChange={(e) => this.handleSearch(e.target.value, this.state.active)}
                            placeholder="Search name or email"
                            className="admin-search-input"
                        />
                        {this.state.isFetchingSearchResults &&
                            <span className="admin-search-spinner">
                                <img src={require("../../../../assets/animations/blue-spinner.svg")} alt="" />
                            </span>
                        }
                    </div>
                </div>

                <UsersListHeader
                    status={true}
                    active={this.state.active}
                    col1={"Candidate"}
                    col2={"Signed up"}
                    col3={this.state.active && "Requested"}
                    col4={"Profile"}
                    col5={"Action"} />

                {this.state.keyword.length > 4 && !this.state.isFetchingSearchResults && this.state.searchResults.length < 1 &&
                    <p className="admin-empty-state">No sign ups match this search.</p>
                }
                {this.state.keyword.length > 4 && !this.state.isFetchingSearchResults && this.state.searchResults.length > 0 &&
                    <UsersList
                        status={true}
                        setAlert={this.props.setAlert}
                        removeCandidateFromTheList={this.props.removeCandidateFromTheList}
                        active={this.state.active}
                        isFetching={this.state.active ? this.props.admin.isFetchingCompletedUsers : this.props.admin.isFetchingIncompleteUsers}
                        users={this.handleUsersList(this.props.admin.completedUsers, this.props.admin.incompleteUsers, this.state.searchResults, this.state.active, this.state.keyword)}
                        isFetchingSearchResults={this.state.isFetchingSearchResults} />
                }
                {this.state.keyword.length < 5 &&
                    <>
                        <UsersList
                            status={true}
                            setAlert={this.props.setAlert}
                            removeCandidateFromTheList={this.props.removeCandidateFromTheList}
                            active={this.state.active}
                            isFetching={this.state.active ? this.props.admin.isFetchingCompletedUsers : this.props.admin.isFetchingIncompleteUsers}
                            users={this.handleUsersList(this.props.admin.completedUsers, this.props.admin.incompleteUsers, this.state.searchResults, this.state.active, this.state.keyword)}
                            isFetchingSearchResults={this.state.isFetchingSearchResults}
                        />
                        {((this.state.active && this.state.hasMoreCompleted && (this.props.admin.completedUsers || []).length > 0)
                          || (!this.state.active && this.state.hasMoreIncomplete && (this.props.admin.incompleteUsers || []).length > 0)) &&
                            <div className="admin-load-more">
                                <button
                                    type="button"
                                    className="admin-page-action admin-page-action--ghost"
                                    onClick={this.handleLoadMore}
                                    disabled={this.state.isFetchingMore}
                                >
                                    {this.state.isFetchingMore ? "Loading…" : "See more sign ups"}
                                </button>
                            </div>
                        }
                    </>
                }
            </div>
        );

    }

}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setUsersCount, setCompletedUsers, setIncompleteUsers, addCompletedUsers, addIncompleteUsers, removeCandidateFromTheList, setAlert }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUps);
